export const EMPTY_DROPDOWN_ITEM = {
  title: '',
  value: null,
}

export const DEBOUNCE_DELAY = {
  short: 300,
  long: 1000,
}

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const
